/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

const WyAnalyticsUtils = {
  configrationMapping: {
    bes: {
      name: 'Bes',
      prefix:'',
      suffix: ''
    },
    bas: {
      name: 'Bas',
      prefix:'',
      suffix: ''
    }
  },
  getHomeExpAndAutoDemoBot1Last30DaysData(){
    return {
      label: 'Demo bot #1 - last 30 days',
      tooltips: 'Displays your BES and BAS for the last 30 days and your target for each',
      data: [
        {
          key: 'BES',
          suffixKey: 'BES',
          label: 'BES',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '75%',
          displayValue: '75%',
          selected: false,
          suffix:'',
          chartData: [],
          pieChartData: {
            title: 'BES',
            tooltips: '',
            labels: ['BES'],
            values: [15, 20, 75],
            percent: [15, 20, 75],
            displayValue: '82%',
            legends: []
          }
        },
        {
          key: 'BES',
          suffixKey: 'BES',
          label: 'BES',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '75%',
          displayValue: '75%',
          selected: false,
          suffix:'',
          chartData: [],
          pieChartData: {
            title: 'BAS',
            tooltips: '',
            labels: ['BAS'],
            values: [15, 20, 75],
            percent: [15, 20, 75],
            displayValue: '55%',
            legends: []
          }
        }
      ]
    }
  },
  getHomeExpAndAutoDemoBot1Last3monthsData(){
    return {
      label: 'Demo bot #1 - last 3 months',
      tooltips: 'Displays a trend for your BES and BAS for the last 3 months',
      data: [
        {
          key: 'bes',
          suffixKey: 'bes',
          label: 'bes',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '75%',
          displayValue: '75%',
          selected: false,
          suffix:'',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'bes',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 3, 10, 25, 35, 45, 55, 65, 75, 85, 95, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['BES'],
              prefix:'',
              suffix: ''
          }
        },
        {
          key: 'bas',
          suffixKey: 'bas',
          label: 'bas',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '40%',
          displayValue: '40%',
          selected: false,
          suffix:'%',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'bas',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 23, 36, 24, 55, 34, 3, 76, 23, 33, 72, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['BAS'],
              prefix:'',
              suffix: '%'
          }
        }
      ]
    }
  },
  getHomeExpAndAutoConverVolLast30DaysData(){
    return {
      label: 'Conversation Volume - last 30 days',
      tooltips: 'Displays a trend for your total, contained and handed conversations for the last 30 days',
      data: [
        {
          key: 'conversations',
          suffixKey: 'conversations',
          label: 'Conversations',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '592.2K',
          displayValue: '592.2K',
          selected: false,
          suffix:'',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'Conversations',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 3, 10, 25, 35, 45, 55, 65, 75, 85, 95, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['conversations'],
              prefix:'',
              suffix: ''
          }
        },
        {
          key: 'contained',
          suffixKey: 'contained',
          label: 'Contained',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '357.1K',
          displayValue: '357.1K',
          selected: false,
          suffix:'',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'Contained',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 23, 36, 24, 55, 34, 3, 76, 23, 33, 72, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['contained'],
              prefix:'',
              suffix: ''
          }
        },
        {
          key: 'handedOff',
          suffixKey: 'handedOff',
          label: 'Handed Off',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '238.1K',
          displayValue: '238.1K',
          selected: false,
          suffix:'',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'Handed Off',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 29, 45, 22, 13, 63, 78, 76, 99, 23, 34, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['handed off'],
              prefix:'',
              suffix: ''
          }
        }
      ]
    }
  },
  getHomeExpAndAutoConverVolLast3mothsData(){
    return {
      label: 'Conversation Volume - last 3 months',
      tooltips: 'Whether or not conversations between a customer <br/> and virtual agent are classified at a confidence level <br/> above the set production threshold. (Whether or <br/> not the bot is understanding customers)',
      data: [
        {
          key: 'conversations',
          suffixKey: 'conversations',
          label: 'Conversations',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '6.55M',
          displayValue: '6.55M',
          selected: false,
          suffix:'',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'Conversations',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 3, 10, 25, 35, 45, 55, 65, 75, 85, 95, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['conversations'],
              prefix:'',
              suffix: ''
          }
        },
        {
          key: 'contained',
          suffixKey: 'contained',
          label: 'Contained',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '3.60M',
          displayValue: '3.60M',
          selected: false,
          suffix:'',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'Contained',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 23, 36, 24, 55, 34, 3, 76, 23, 33, 72, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['contained'],
              prefix:'',
              suffix: ''
          }
        },
        {
          key: 'handedOff',
          suffixKey: 'handedOff',
          label: 'Handed Off',
        //   subLabel: 'Feedback rate - positive, negative, and no feedback',
          value: '238.1K',
          displayValue: '238.1K',
          selected: false,
          suffix:'',
          chartData: [],
          lineChartData: {
              // title: '',
              title: 'Handed Off',
              tooltips: '',
              xAxisData: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
              yAxisData: [0, 29, 45, 22, 13, 63, 78, 76, 99, 23, 34, 100],
              // yAxisData: [null, null, null, null, null, null, null, null, null, null, null, null],
              legends: ['handed off'],
              prefix:'',
              suffix: ''
          }
        }
      ]
    }
  },
}

export default WyAnalyticsUtils;